import { httpsCallable } from "firebase/functions";
import { functions } from "./ambiente";

/* O prefixo `nhomi` no nome publicado não é enfeite: o GymEats vive no
   mesmo projeto e na mesma região, e nome de Cloud Function é único aí.
   Ver o comentário em functions/src/index.ts. */

export interface ValeFaltaUsado {
  ok: boolean;
  dia: string;
  /** O tamanho da sequência depois de cobrir o dia. */
  sequencia: number;
}

/**
 * Gasta um vale-falta num dia perdido.
 *
 * Quem decide se pode é o servidor, com a mesma função do core que a
 * tela usa para desenhar o convite — a tela só evita pedir o que já sabe
 * que vai ser recusado. Recusa vem como `failed-precondition` com a
 * mensagem já em português.
 */
export async function usarValeFalta(cid: string, dia: string): Promise<ValeFaltaUsado> {
  const chamar = httpsCallable<{ cid: string; dia: string }, ValeFaltaUsado>(
    functions, "nhomiUsarValeFalta");
  const { data } = await chamar({ cid, dia });
  return data;
}

/** Troca pontos do total por um vale-falta. Recusa vem em português. */
export async function trocarPontosPorVale(cid: string): Promise<{ ok: boolean; preco: number }> {
  const chamar = httpsCallable<{ cid: string }, { ok: boolean; preco: number }>(
    functions, "nhomiTrocarPontosPorVale");
  const { data } = await chamar({ cid });
  return data;
}
